import {routes} from './oportunidade.routes';
import OportunidadeListController from "./directory/directory.controller";
import OportunidadeService from "./oportunidade.service";
import OportunidadeDetailsController from "./details/details.controller";
import OportunidadeCreateOportunidadeController from "./new/new.controller";
import OportunidadeFileUploaderController from "./details/files.dialog.controller";

export default angular.module('app.oportunidade', [])
  .config(routes)
  .controller('OportunidadeListController', OportunidadeListController)
  .service('OportunidadeService', OportunidadeService)
  .controller('OportunidadeDetailsController', OportunidadeDetailsController)
  .controller('OportunidadeCreateOportunidadeController', OportunidadeCreateOportunidadeController)
  .controller('OportunidadeFileUploaderController', OportunidadeFileUploaderController)
  .name;
